export interface GetUploadFileTypesParams {
  page?: number
  size?: number
  query?: string
}

const uploadFileType = {
  getUploadFileTypes: ({ page = 1, size = 100, query }: GetUploadFileTypesParams = {}): string => {
    const params = new URLSearchParams()
    params.set('page', String(page))
    params.set('size', String(size))

    if (query) {
      params.set('query', query)
    }

    return `api/v2.5/upload_file_types?${params.toString()}`
  },
}

export default uploadFileType
